// pages/FormViewerPage/services/formViewerService/variantOptions.ts — opsi varian produk (split dari options.ts)
import type { Form } from '../../../../types';

export function computeDerivedOptions(form: Form | null): Form['productOptions'] {
    if (!form || !form.variantCombinations || form.variantCombinations.length === 0) return [];
    const firstCombo = form.variantCombinations[0];
    const optionNames = Object.keys(firstCombo.attributes || {});
    return optionNames.map((name, idx) => ({
        id: idx + 1,
        name,
        values: Array.from(new Set(form.variantCombinations.map(vc => vc.attributes[name]).filter(Boolean))),
        displayStyle: 'radio' as const,
    }));
}

export function computeCompositeFallback(derivedOptions: Form['productOptions']) {
    if (derivedOptions.length !== 1) return null;
    const [singleOption] = derivedOptions;
    const separator = ' - ';
    const splitValues = singleOption.values.map((v: string) => v.split('-').map((p: string) => p.trim())).filter((parts: string[]) => parts.length === 2 && parts[0] && parts[1]);
    if (splitValues.length !== singleOption.values.length) return null;
    const attr1Values = Array.from(new Set(splitValues.map((parts: string[]) => parts[0])));
    const attr2Values = Array.from(new Set(splitValues.map((parts: string[]) => parts[1])));
    return {
        options: [
            { id: 1, name: 'Atribut 1', values: attr1Values, displayStyle: 'radio' as const },
            { id: 2, name: 'Atribut 2', values: attr2Values, displayStyle: 'radio' as const }
        ],
        separator,
        originalAttributeKey: singleOption.name,
        buildCombinedValue: (sel: Record<string, string>) => {
            const f = sel['Atribut 1'], s = sel['Atribut 2'];
            return (f && s) ? `${f} - ${s}` : null;
        }
    };
}

export function computeResolvedVariantCombinations(
    combinations: any[],
    productOptionsOverride: Form['productOptions']
): any[] {
    const base = combinations || [];
    if (!base.length) return [];
    if (productOptionsOverride.length > 1) {
        return base.map(combo => {
            const attrs = { ...(combo.attributes || {}) };
            const alreadyComplete = productOptionsOverride.every(opt => attrs.hasOwnProperty(opt.name));
            if (alreadyComplete) return combo;
            const firstKey = Object.keys(attrs)[0];
            const combined = firstKey ? attrs[firstKey] || '' : '';
            const parts = (combined || '').split('-').map((p: string) => p.trim());
            const rebuilt: Record<string, string> = {};
            productOptionsOverride.forEach((opt, idx) => { rebuilt[opt.name] = parts[idx] || opt.values[0] || ''; });
            return { ...combo, attributes: rebuilt };
        });
    }
    return base;
}

export function computeDisplayOptions(
    form: Form | null,
    derivedOptions: Form['productOptions'],
    productOptionsOverride: Form['productOptions'],
    compositeFallback: any
): Form['productOptions'] {
    if (!form) return [];
    if (Array.isArray(form.productOptions) && form.productOptions.length > 0) return form.productOptions;
    if (productOptionsOverride.length > 0) return productOptionsOverride;
    if (compositeFallback) return compositeFallback.options;
    return derivedOptions;
}
